import { Link, useNavigate } from "react-router-dom";
import { Button } from "@satyrsmc/shared/components";

export function UnauthorizedPage() {
  const navigate = useNavigate();
  return (
    <main className="flex min-h-[60vh] flex-col items-center justify-center p-4 md:p-6">
      <div className="text-center">
        <p className="text-6xl font-bold text-muted-foreground">403</p>
        <h1 className="mt-2 text-xl font-semibold">Access denied</h1>
        <p className="mt-2 max-w-sm text-muted-foreground">
          You don't have permission to view this page.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Button variant="outline" onClick={() => navigate(-1)}>
            Go back
          </Button>
          <Button asChild>
            <Link to="/login">Back to Login</Link>
          </Button>
        </div>
      </div>
    </main>
  );
}
